import React, { useState } from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import mouseLeft from '../Resources/Icons/mouse-left.svg';
import mouseRight from '../Resources/Icons/mouse-right.svg';
import mouseMiddle from '../Resources/Icons/mouse-middle.svg';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles(
  (theme) => ({
    card: {
      marginBottom: 10,
      borderTop: '7px solid ' + theme.palette.primary.main,
      padding: 15,
      overflow: 'visible',
    },
    gridContainer: {
      paddingBottom: 10,
    },
    icon: {
      maxWidth: 30,
    },
    gridTextItem: {
      display: 'flex',
      alignItems: 'center',
    },
    closeIcon: {
      position: 'absolute',
      right: 15,
      top: 15,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  }),
  {
    name: 'ControlsHelperDialogue',
  }
);

const ControlsHelperDialogue = () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isOpen || isMobile) {
    return null;
  }
  return (
    <Card className={classes.card}>
      <Typography variant="h6">
        <b>{t('controlsHelper.controls')}</b>
      </Typography>
      <Icon className={classes.closeIcon} onClick={() => setIsOpen(false)}>
        close
      </Icon>
      <Grid item xs={12} sm={12} spacing={5}>
        <CardContent>
          <Grid container className={classes.gridContainer}>
            <Grid item xs={3}>
              <img src={mouseLeft} alt="left mouse button" className={classes.icon} />
            </Grid>
            <Grid item xs={9} className={classes.gridTextItem}>
              <Typography variant="body2">
                <b>{t('controlsHelper.leftMouseButtonHint')}</b>
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.gridContainer}>
            <Grid item xs={3}>
              <img src={mouseRight} alt="right mouse button" className={classes.icon} />
            </Grid>
            <Grid item xs={9} className={classes.gridTextItem}>
              <Typography variant="body2">
                <b>{t('controlsHelper.rightMouseButtonHint')}</b>
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={3}>
              <img src={mouseMiddle} alt="mouse scrollwhell" className={classes.icon} />
            </Grid>
            <Grid item xs={9} className={classes.gridTextItem}>
              <Typography variant="body2">
                <b>{t('controlsHelper.scrollWheelHint')}</b>
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default ControlsHelperDialogue;
